import Manage from './manage_cf'
import { connect } from 'react-redux'
import { getCampaignSelector } from 'redux/selectors/campaign'
import { push } from 'react-router-redux'
import { glimpseRoute } from 'lib/route_utils'

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)

  return {
    hasChippedIn: campaign.current_value > 0,
    hasMoneybox: campaign.moneybox_amount > 0,
    currencyCode: campaign.currency,
    hasCurrencyBalance: campaign.has_currency_balance,
    currentValue: campaign.current_value + campaign.pledge,
    goal: campaign.goal,
  }
}

const mapDispatchToProps = (dispatch, { campaignId }) => {
  return {
    onTransfer() {
      dispatch(push({ pathname: glimpseRoute('edit', 'transfer') }))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Manage)
